import React, { memo } from "react";
import classnames from "classnames";
import { Element } from "../base";

interface IProps {
    className?: string;
    children: React.ReactNode;
}

export function MessageHeader(props: IProps) {
    const { className, children, ...rest } = props;
    return (
        <Element className={classnames("message-header", className)} {...rest}>
            {children}
        </Element>
    );
}

export default memo(MessageHeader);
